module.exports = __webpack_public_path__ + "img/point-bg.b747a4b9.png";